import { useState, useMemo, useCallback, useEffect, useContext } from "react";
import {
    Box,
    Stack,
    Typography,
    Card,
    Grid,
    CardContent,
} from "@mui/material";
import { useGridApiRef, getGridStringOperators } from "@mui/x-data-grid";
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";


import NodataImg from "../../assets/images/noData.png";
import { useDispatch, useSelector } from "react-redux";
import { CourseProgressByIdApi } from "../../store/analytics/courseProgressById";
import { ThemeContext } from '../../context/ThemeContext';



import BackdropUI from "../../ui/Backdrop";
import DataGridComponent from "../../components/DataGridComponent";
import Appbar from "../../components/Appbar";
import DrawerComponent from "../../components/Drawer";
import Body from "../../components/Body";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";



const courseColumns = [
    {
        field: "id",
        headerName: "ID",
        width: 100,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "course_id",
        headerName: "Course ID",
        width: 120,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "course_name",
        headerName: "Course Name",
        width: 250,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "course_id_check",
        headerName: "Course ID Check",
        width: 220,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "user_id",
        headerName: "User ID",
        width: 120,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "fullname",
        headerName: "Full Name",
        width: 200,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "username",
        headerName: "Username",
        width: 150,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "email",
        headerName: "Email",
        width: 250,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "state",
        headerName: "State",
        width: 150,
        disableColumnMenu: true,
        filterable: false,
        filterOperators: getGridStringOperators().filter(
            (operator) => operator.value === "equals" || operator.value === "contains"
        ),
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "channel_code",
        headerName: "Channel Code",
        width: 140,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "total_time_spent",
        headerName: "Total Time Spent",
        width: 160,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "like",
        headerName: "Likes",
        width: 100,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "bookmark",
        headerName: "Bookmarks",
        width: 100,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "certificate_generation",
        headerName: "Certificate Gen.",
        width: 160,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "enrollment_date",
        headerName: "Enrollment Date",
        width: 180,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => {
            return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
        }
    },
    {
        field: "grade",
        headerName: "Score (%)",
        width: 100,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "total_modules",
        headerName: "Total Modules",
        width: 140,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "completed_modules",
        headerName: "Completed Modules",
        width: 160,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    },
    {
        field: "completion_percentage",
        headerName: "Completion Percentage (%)",
        width: 160,
        disableColumnMenu: true,
        filterable: false,
        sortable: false,
        disableColumnMenu: true,
    }
];


export default function CourseProgressById({ graphData, region, state, loading, type, module, monthDaily, startDate, endDate, isMaskingEnabled, schoolType }) {

    const apiRef = useGridApiRef();
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const historyLocation = useLocation();
    const [isDownload, setIsDownload] = useState(false)
    const CourseProgressByIdTable = useSelector((state) => state?.CourseProgressByIdTable);
    const { result: tableResult, loading: tableLoading, total } = CourseProgressByIdTable;
    const [queryOptions, setQueryOptions] = useState({});
    const { paginationModel, setPaginationModel } = useContext(ThemeContext)

    const onFilterChange = useCallback((filterModel) => {
        setQueryOptions({ filterModel: { ...filterModel } });
    }, []);
    // const toggleTeacherRegistration = useCallback((key) => {
    //     setTeacherRegistration(prevState => ({ ...prevState, [key]: !prevState[key] }));
    // }, []);
    // const toggleActiveVsAvgTimeSpent = useCallback((key) => {
    //     setActiveVsAvgTimeSpent(prevState => ({ ...prevState, [key]: !prevState[key] }));
    // }, []);
    const getRowSpacing = useCallback((params) => {
        return {
            top: params.isFirstVisible ? 0 : 5,
            bottom: params.isLastVisible ? 0 : 5,
        };
    }, []);
    const handleSortModelChange = useCallback((sortModel) => {
        setQueryOptions({ sortModel: [...sortModel] });
    }, []);


    useEffect(() => {
        // console.log("isMaskingEnabled",isMaskingEnabled);
        const filterModel = queryOptions?.filterModel;
        const items = filterModel?.items;
        const firstItem = items && items.length > 0 ? items[0] : {};
        const quickFilterValues = filterModel?.quickFilterValues;
        const sortModel = queryOptions?.sortModel;
        let query
        if (sortModel?.length > 0) {
            query = {
                module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                sort_order: sortModel[0].sort || "desc",
                field: firstItem.field || '',
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        } else {
            query = {
                course_id: params?.id,
                module_type: module,
                school_type: schoolType,
                page: paginationModel?.page + 1,
                page_size: paginationModel?.pageSize,
                field: firstItem.field || '',
                city: region,
                sort_order: "desc",
                state: state,
                startDate: startDate,
                endDate: endDate,
                operator: firstItem.operator || (quickFilterValues && "contains") || '',
                value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
            };
        }
        dispatch(CourseProgressByIdApi(query));
    }, [dispatch, queryOptions, paginationModel, region, state, module, startDate, endDate, isMaskingEnabled, schoolType]);

    // console.log("tableResult", tableResult);
    const { courseName, tabIndex } = historyLocation.state || {};

    useEffect(() => {

        sessionStorage.setItem('analyticsTabIndex', '6');
        window.history.pushState({ tabIndex: 6 }, '');

        const handlePopState = (event) => {
            navigate('/get-analytics', {
                replace: true,
                state: { tabIndex: 6 }
            });
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [navigate]);



    return (
        <>

            <Appbar />
            <DrawerComponent />
            <Body>
                <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center" justifyContent={"space-between"}>
                    <Typography variant="h3">Course Progress of {courseName}</Typography>
                </Stack>
                <Stack direction="row" spacing={1} sx={{ my: 2, padding: "10px" }} alignItems="center">
                    <DataGridComponent
                        disableColumnMenu
                        disableColumnSorting
                        loading={tableLoading}
                        rowCount={total}
                        pageSize={paginationModel?.pageSize}
                        onPageSizeChange={(newPageSize) => {
                            setPaginationModel({
                                ...paginationModel,
                                pageSize: newPageSize,
                            })
                        }}
                        paginationModel={paginationModel}
                        onPaginationModelChange={setPaginationModel}
                        sx={{
                            height: 500
                        }}
                        rows={tableResult}
                        getRowId={(r) => {
                            return module === "course" ? r['s.no'] : r['id']
                        }}
                        getRowSpacing={getRowSpacing}
                        columns={courseColumns}
                        onSortModelChange={handleSortModelChange}
                        onFilterModelChange={onFilterChange}
                        slots={{
                            noRowsOverlay: () => (
                                <Box className="noData">
                                    <img src={NodataImg} alt="no data found" />
                                </Box>
                            ),
                            toolbar: (props) =>
                            (CustomGridToolbar({
                                ...props, moduleType: "CourseProgress", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload,
                                apiUrl: `${apiRoutes.courseProgressCsvExportById}`,
                                download_csv: true,
                                hasfilter: false,
                                hasSearch: false,
                                region: region,
                                state: state,
                                startDate: startDate,
                                endDate: endDate,
                                course_id: params?.id
                            })),
                        }}
                        slotProps={{
                            loadingOverlay: {
                                variant: 'linear-progress',
                                noRowsVariant: 'linear-progress',
                            },
                            toolbar: {
                                // showQuickFilter: true,
                                showQuickFilter: false,
                            },
                        }}
                    />
                </Stack>
                <BackdropUI open={isDownload} />
            </Body>
        </>)
}

